interface CurvedTriangleProps {
  direction?: 'left' | 'right'
  color?: string
  width?: number
  height?: number
  boxShadow?: string
}

const CurvedTriangle: React.FC<CurvedTriangleProps> = ({
  direction = 'right',
  color = '#d32f2f',
  width = 40,
  height = 40,
  boxShadow = '',
}) => {
  const rightPath = `M0 0 Q${width * 0.4} ${height * 1} ${width} ${height} L0 ${height} Z`
  const leftPath = `M${width} 0 Q${width * 0.6} ${height * 1} 0 ${height} L${width} ${height} Z`

  return (
    <svg
      width={width}
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block', boxShadow: `${boxShadow}` }}
    >
      <path d={direction == 'right' ? rightPath : leftPath} fill={color} />
    </svg>
  )
}

export default CurvedTriangle
